// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Qhvo4","newExpiryDate":"styles_newExpiryDate__ihYAg","footer":"styles_footer__LskbR"};